import { withNamespaces } from 'react-i18next';
import {
    Col,
    Container,
    Row,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import CarriersList from './list';

const GuardCarriersList = ({
    t,
}) => {
    return (
        <div className="page-content carrier-guard-page carrier-guard-carriers-page">
            <Container fluid>
                <Row>
                    <Col className="mb-4" lg="12">
                        <Navigator
                            pageTitle={t('Third Party Management')}
                            translate={false}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg="12">
                        <CarriersList />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withNamespaces()(GuardCarriersList);
